'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToImages = ['one'];

  switch (action.type) {

    case 'DELETE_IMAGE_START':
    case 'GET_PRE_SIGNED_URL_START':
      {
        return state.setIn(pathToImages, (state.getIn([].concat(pathToImages)) || (0, _immutable.Map)()).merge((0, _immutable.Map)({ loading: true })));
      }

    case 'GET_IMAGES':
      return (0, _immutable.fromJS)(action.payload).reduce(function (state, i) {
        return state.setIn([].concat(pathToImages, [i.get('id')]), i);
      }, state);

    case 'UPLOAD_IMAGE':
      {
        return state.setIn(pathToImages.concat([action.payload.id]), (0, _immutable.fromJS)(action.payload)).deleteIn([].concat(pathToImages, ['loading']));
      }

    case 'DELETE_IMAGE':
      {
        return state.deleteIn(state.getIn([].concat(pathToImages, [action.image_id]))).deleteIn([].concat(pathToImages, ['loading']));
      }

    case 'DELETE_IMAGE_ERROR':
    case 'GET_PRE_SIGNED_URL_ERROR':
      {
        return state.deleteIn([].concat(pathToImages, ['loading']));
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/images/index.js
// module id = 703
// module chunks = 0